/* Embroidery Inc crew kit builder (2026-10-21). Opened from each kit card in sections/ei-industry-kits
   ("Customize and add to cart"). Three steps in one modal <dialog>: 1 colors + sizes + quantities, 2 logo,
   3 review + add. Data: <script type="application/json" data-ei-kit-data> (snippets/ei-kit-data).
   - Pricing = snippets/ei-industry-kit-price: tiers by total items in this request (12+ 5%, 24+ 10%, 48+ 15%),
     total = round(list x (100 - pct) / 100) + 3000 cents under 12 items (waived for a reorder), integer cents.
   - Add = ONE POST /cart/add.js {"items":[{id, quantity, properties:{"_type":"product","_product_type","_features"}}]}
     with the properties the PDP writes (snippets/ei-kit-props mirrors the PDP classifier).
   - Shopify adds what it can on a 422 (partial add). The cart is read before the add; on any failure every line
     the request grew is put back, so a failed add never leaves half a kit in the cart.
   - Success: a fresh upload is stored (ei-logo:v1, src "kit") and offered (ei:logo:offer), then __cart_reload,
     wait for the cart engine to go idle, then /cart (the engine's tag map freezes per page).
   - Never defines window.__eiCart, never writes order attributes or notes, never logs the logo url or name. */
(function () {
  'use strict';
  if (window.__eiKitBuilder) return;
  window.__eiKitBuilder = true;

  var COLLAPSE = 12;
  var MAXQ = 9999;
  var mqReduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  /* ---------------- copy ---------------- */
  function nItems(n) { return n === 1 ? '1 item' : n + ' items'; }
  var C = {
    eyebrow: 'Crew kit builder',
    steps: ['Colors and sizes', 'Your logo', 'Review'],
    stepOf: function (n) { return 'Step ' + n + ' of 3'; },
    close: 'Close',
    back: 'Back',
    next1: 'Next: your logo',
    next2: 'Next: review',
    add: function (n) { return 'Add ' + nItems(n) + ' to cart'; },
    adding: 'Adding to cart',
    finishing: 'Finishing your upload',
    added: 'Added. Opening your cart',
    s1h: 'Pick colors and sizes',
    s1lede: function (u) { return 'One of each item per ' + u + '. Every price includes your logo stitched in one spot.'; },
    crewL: 'Outfitting',
    crewLess: 'One fewer person',
    crewMore: 'One more person',
    crewInput: 'Number of people',
    each: function (m) { return m + ' each'; },
    from: function (m) { return 'from ' + m; },
    need: function (n, u) { return n + ' needed, 1 per ' + u; },
    picked: function (q, n) { return q + ' of ' + n; },
    pickedSr: function (q, n, name) { return q + ' of ' + n + ' ' + name + ' picked'; },
    colorsL: 'Colors',
    showAll: function (n) { return 'Show all ' + n + ' colors'; },
    showFewer: 'Show fewer colors',
    soldOut: 'Sold out',
    remove: function (s) { return 'Remove ' + s; },
    qtyFor: function (s) { return s + ', quantity'; },
    less: function (s) { return 'One fewer ' + s; },
    more: function (s) { return 'One more ' + s; },
    sizesFor: function (s) { return 'Sizes for ' + s; },
    sizeQty: function (sz, col) { return col + ', size ' + sz + ', quantity'; },
    sizedHint: 'Pick a color, then type how many of each size.',
    unsizedHint: 'Pick colors and set how many of each.',
    rowPicked: function (n) { return n + ' picked'; },
    added1: function (s) { return s + ' added.'; },
    removed1: function (s) { return s + ' removed.'; },
    needOne: 'Pick at least one item to keep going.',
    inCart: function (n) { return 'You already have ' + nItems(n) + ' in your cart. They count toward your bulk discount too.'; },
    s2h: 'Add your logo',
    s2lede: 'We stitch it on every item. One logo in one spot is included in the price.',
    logoLegend: 'How do you want to add your logo?',
    optSaved: 'Use my saved logo',
    optUpload: 'Upload my logo',
    optUploadSub: 'PNG, JPG, SVG, PDF, AI or EPS, up to 25 MB.',
    optReorder: "I've ordered with this logo before",
    optReorderSub: "Pick Reorder in your cart and we'll use the logo on file. The $30 digitizing fee is waived on reorders.",
    optLater: "I'll upload it in the cart",
    optLaterSub: 'Add your items now and upload it before checkout.',
    proof: 'We stitch a real proof on a test hat in 24-48 hours. You approve it or ask for changes before we make the rest.',
    s3h: 'Review your kit',
    none: 'None picked',
    logoL: 'Logo',
    logoNew: 'Your new logo',
    logoSaved: 'Your saved logo',
    logoReorder: "Reorder. Pick Reorder in your cart and we'll use the logo on file.",
    logoLater: "You'll upload it in your cart.",
    logoNotYet: "Not uploaded yet. You can add it in your cart.",
    rowItems: function (n) { return 'Items (' + n + ')'; },
    rowDisc: function (p) { return 'Bulk discount (' + p + '%)'; },
    rowFee: 'Digitizing and proof',
    waived: 'Waived',
    waivedReorder: 'Waived on reorders',
    estTotal: 'Estimated total',
    fine: 'Before tax and shipping. Bulk discounts apply automatically in your cart.',
    totalL: 'Estimated total',
    noItems: 'No items yet',
    standard: 'Standard price',
    off: function (p) { return p + '% off'; },
    feeIn: function (f) { return 'includes ' + f + ' digitizing'; },
    feeWaived: 'digitizing fee waived',
    feeReorder: 'digitizing free on reorders',
    nudge0: 'Pick colors and quantities to see your price.',
    nudge12: function (n, f) { return 'Add ' + n + ' more ' + (n === 1 ? 'item' : 'items') + ' to get 5% off and skip the ' + f + ' digitizing fee.'; },
    nudgeT: function (n, p) { return 'Add ' + n + ' more ' + (n === 1 ? 'item' : 'items') + ' to get ' + p + '% off.'; },
    nudgeTop: "You're at our best bulk price: 15% off.",
    liveTotal: function (n, m) { return nItems(n) + '. Estimated total ' + m + '.'; },
    errStock: 'Some of these are low on stock, so nothing was added yet. We changed:',
    errStockTail: 'Check the changes and add again.',
    errStockNone: 'Some of these just sold out, so nothing was added yet. Check your colors and sizes and try again.',
    adj: function (label, n) { return n > 0 ? label + ': only ' + n + ' left, so we set it to ' + n + '.' : label + ': sold out, so we took it off.'; },
    errGeneric: "We couldn't add your kit, and nothing was added. Please try again.",
    errPartial: 'Some items were added before we hit a stock limit. Check your cart before you order.',
    errUnknown: "We couldn't confirm what made it into your cart. Check your cart before you try again.",
    goCart: 'Open my cart',
    soldOutRow: 'Sold out. Remove it to continue.'
  };

  /* ---------------- helpers ---------------- */
  function h(tag, attrs, kids) {
    var el = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!Object.prototype.hasOwnProperty.call(attrs, k)) continue;
        var v = attrs[k];
        if (v == null || v === false) continue;
        if (k === 'text') el.textContent = v;
        else if (k === 'html') el.innerHTML = v;
        else if (k === 'class') el.className = v;
        else if (k.slice(0, 2) === 'on' && typeof v === 'function') el.addEventListener(k.slice(2), v);
        else el.setAttribute(k, v === true ? '' : v);
      }
    }
    (kids || []).forEach(function (c) { if (c != null && c !== false) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }
  var ICON = {
    close: '<path d="M6 6l12 12M18 6L6 18"/>',
    back: '<path d="M15 18l-6-6 6-6"/>',
    next: '<path d="M5 12h14"/><path d="M13 6l6 6-6 6"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    minus: '<path d="M5 12h14"/>',
    alert: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5"/><path d="M12 16.5h.01"/>',
    cart: '<circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3.5h3l2.6 12h11l2-8.5H6.4"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5.5"/><path d="M12 7.6h.01"/>',
    refresh: '<path d="M20 11a8 8 0 0 0-14.6-4.5L3 9"/><path d="M3 4v5h5"/><path d="M4 13a8 8 0 0 0 14.6 4.5L21 15"/><path d="M21 20v-5h-5"/>',
    upload: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M17 8l-5-5-5 5"/><path d="M12 3v12"/>'
  };
  function ic(n, cls) {
    return '<svg class="ei-kb-ic' + (cls ? ' ' + cls : '') + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + ICON[n] + '</svg>';
  }
  /* Color names break after a slash ("Black/" + "Charcoal"), never inside a word. */
  function nameEl(tag, cls, name) {
    var e = document.createElement(tag);
    e.className = cls;
    String(name).split('/').forEach(function (part, i, all) {
      e.appendChild(document.createTextNode(part + (i < all.length - 1 ? '/' : '')));
      if (i < all.length - 1) e.appendChild(document.createElement('wbr'));
    });
    return e;
  }
  function prodImg(st, P) {
    var ci = st.sel[P.pi] && st.sel[P.pi].length ? st.sel[P.pi][0] : P.d;
    return (P.cols[ci] && P.cols[ci].img) || P.img;
  }
  function tierFor(n) { return n >= 48 ? 15 : n >= 24 ? 10 : n >= 12 ? 5 : 0; }
  function still() { return !!(mqReduce && mqReduce.matches); }
  function L() { return window.__eiLogo || null; }
  function sleep(ms) { return new Promise(function (r) { window.setTimeout(r, ms); }); }
  function clampQ(s) {
    var n = parseInt(String(s).replace(/[^0-9]/g, ''), 10);
    if (!isFinite(n) || n < 0) n = 0;
    return Math.min(MAXQ, n);
  }

  function getJSON(url) {
    return fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try { j = JSON.parse(t); } catch (e) { j = null; }
        return { ok: r.ok, status: r.status, json: j };
      });
    }).catch(function () { return { ok: false, status: 0, json: null }; });
  }
  function rootUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function cartJsUrl() { return rootUrl() + 'cart.js'; }
  function changeUrl() { return rootUrl() + 'cart/change.js'; }

  /* ---------------- data ---------------- */
  var cache = new WeakMap();
  function dataFor(section) {
    if (cache.has(section)) return cache.get(section);
    var tag = section.querySelector('script[data-ei-kit-data]');
    var D = null;
    try { D = tag ? JSON.parse(tag.textContent) : null; } catch (e) { D = null; }
    if (D && D.p && D.k) prep(D);
    else D = null;
    cache.set(section, D);
    return D;
  }
  function prep(D) {
    var fmt;
    try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: D.cur || 'USD' }); }
    catch (e) { fmt = { format: function (v) { return '$' + v.toFixed(2); } }; }
    D.money = function (c) { return fmt.format(Math.round(c) / 100); };
    D.feeText = D.money(D.fee).replace(/\.00$/, '');
    D.p.forEach(function (P, pi) {
      P.pi = pi;
      P.sized = !!(P.z && P.z.length);
      P.cols = P.c.map(function (c, ci) { return { ci: ci, name: c[0], img: c[1], vars: [], bySi: {}, av: false }; });
      P.byId = {};
      P.v.forEach(function (a) {
        var v = { id: a[0], ci: a[1], si: a[2], price: a[3], av: a[4] === 1 };
        var col = P.cols[v.ci];
        if (!col) return;
        P.byId[v.id] = v;
        col.vars.push(v);
        col.bySi[v.si] = v;
        if (v.av) col.av = true;
      });
      range(P);
    });
  }
  function range(P) {
    var mn = Infinity, mx = 0;
    for (var id in P.byId) {
      var p = P.byId[id].price;
      if (p < mn) mn = p;
      if (p > mx) mx = p;
    }
    P.min = mn === Infinity ? 0 : mn;
    P.max = mx;
  }
  function firstAv(P) {
    for (var i = 0; i < P.cols.length; i++) if (P.cols[i].av) return i;
    return -1;
  }
  /* Live availability + price from /products/<handle>.js (the page HTML can be a few minutes old). */
  var refreshed = new WeakMap();
  function refresh(D) {
    if (refreshed.has(D)) return refreshed.get(D);
    var changed = false;
    var jobs = D.p.map(function (P) {
      if (!P.u) return Promise.resolve();
      return getJSON(P.u.split('?')[0] + '.js').then(function (j) {
        if (!j || !j.variants) return;
        j.variants.forEach(function (jv) {
          var v = P.byId[jv.id];
          if (!v) return;
          var av = !!jv.available;
          if (v.av !== av) { v.av = av; changed = true; }
          if (typeof jv.price === 'number' && jv.price > 0 && jv.price !== v.price) { v.price = jv.price; changed = true; }
        });
        P.cols.forEach(function (col) { col.av = col.vars.some(function (v) { return v.av; }); });
        range(P);
      });
    });
    var p = Promise.all(jobs).catch(function () {}).then(function () { return changed; });
    refreshed.set(D, p);
    return p;
  }

  /* ---------------- state ---------------- */
  var states = new WeakMap();
  function stateFor(section, D, k, crew) {
    var byKit = states.get(section);
    if (!byKit) { byKit = {}; states.set(section, byKit); }
    var st = byKit[k];
    if (st && st.pristine && st.crew !== crew) st = null;
    if (!st) {
      st = makeState(D, k, crew);
      byKit[k] = st;
    }
    return st;
  }
  function makeState(D, k, crew) {
    var st = { D: D, k: k, kit: D.k[k], crew: crew, step: 1, pristine: true, lines: {}, sel: {}, more: {}, vmap: {}, logo: 'upload', up: null, cartCount: null, cartSnap: null };
    st.kit.p.forEach(function (pi) {
      var P = D.p[pi];
      for (var id in P.byId) st.vmap[id] = pi;
      st.sel[pi] = [];
      var d = P.cols[P.d] && P.cols[P.d].av ? P.d : firstAv(P);
      if (d < 0) return;
      st.sel[pi].push(d);
      if (!P.sized) {
        var v = P.cols[d].bySi[-1] || P.cols[d].vars[0];
        if (v && v.av) st.lines[v.id] = crew;
      }
    });
    var saved = L() && L().read();
    st.logo = saved ? 'saved' : 'upload';
    return st;
  }
  function qOf(st, id) { return st.lines[id] || 0; }
  function setQ(st, id, q) {
    if (q > 0) st.lines[id] = q;
    else delete st.lines[id];
    st.pristine = false;
  }
  function prodCount(st, pi) {
    var P = st.D.p[pi], n = 0;
    for (var id in st.lines) if (st.vmap[id] === pi) n += st.lines[id];
    return n;
  }
  function colCount(st, P, ci) {
    var n = 0;
    P.cols[ci].vars.forEach(function (v) { n += qOf(st, v.id); });
    return n;
  }
  function calc(st) {
    var items = 0, list = 0;
    for (var id in st.lines) {
      var pi = st.vmap[id];
      if (pi == null) continue;
      var v = st.D.p[pi].byId[id];
      var q = st.lines[id];
      if (!v || !(q > 0)) continue;
      items += q;
      list += q * v.price;
    }
    var pct = tierFor(items);
    var disc = Math.round(list * (100 - pct) / 100);
    var reorder = st.logo === 'reorder';
    var fee = items > 0 && items < st.D.waive && !reorder ? st.D.fee : 0;
    return { items: items, list: list, pct: pct, disc: disc, save: list - disc, fee: fee, reorder: reorder, total: disc + fee };
  }
  function nudge(st, t) {
    var D = st.D;
    if (t.items === 0) return C.nudge0;
    if (t.items < 12) return t.reorder ? C.nudgeT(12 - t.items, 5) : C.nudge12(12 - t.items, D.feeText);
    if (t.items < 24) return C.nudgeT(24 - t.items, 10);
    if (t.items < 48) return C.nudgeT(48 - t.items, 15);
    return C.nudgeTop;
  }
  function soldOutPicked(st) {
    var bad = [];
    for (var id in st.lines) {
      var pi = st.vmap[id];
      var v = pi != null && st.D.p[pi].byId[id];
      if (v && !v.av) bad.push(v);
    }
    return bad;
  }

  /* ---------------- dialog shell ---------------- */
  var dlg, el = {}, cur = null, opener = null, pushed = false, closing = false, busy = false, liveTimer = 0;

  function build() {
    dlg = h('dialog', { class: 'ei-kb', 'aria-labelledby': 'ei-kb-title' });
    el.back = h('button', { type: 'button', class: 'ei-kb__icon ei-kb__back', 'aria-label': C.back, html: ic('back') });
    el.x = h('button', { type: 'button', class: 'ei-kb__icon ei-kb__x', 'aria-label': C.close, html: ic('close') });
    el.eyeD = h('span', { class: 'ei-kb__eye-d' });
    el.eyeM = h('span', { class: 'ei-kb__eye-m' });
    el.eyebrow = h('p', { class: 'ei-kb__eyebrow' }, [el.eyeD, el.eyeM]);
    el.title = h('h2', { class: 'ei-kb__title', id: 'ei-kb-title', tabindex: '-1' });
    el.steps = h('ol', { class: 'ei-kb__steps' });
    C.steps.forEach(function (s, i) {
      el.steps.appendChild(h('li', { 'data-n': String(i + 1) }, [h('span', { class: 'ei-kb__stepn', text: String(i + 1) }), h('span', { class: 'ei-kb__stepl', text: s })]));
    });
    var head = h('header', { class: 'ei-kb__head' }, [
      el.back,
      h('div', { class: 'ei-kb__titles' }, [el.eyebrow, el.title]),
      el.steps,
      el.x
    ]);
    el.body = h('div', { class: 'ei-kb__body' });
    el.total = h('b', { class: 'ei-kb__total' });
    el.meta = h('p', { class: 'ei-kb__meta' });
    el.nudge = h('p', { class: 'ei-kb__nudge' });
    el.ferr = h('p', { class: 'ei-kb__ferr', role: 'alert' });
    el.prev = h('button', { type: 'button', class: 'ei-kb__btn ei-kb__btn--ghost ei-kb__prev', text: C.back });
    el.next = h('button', { type: 'button', class: 'ei-kb__btn ei-kb__btn--primary ei-kb__next' });
    var foot = h('footer', { class: 'ei-kb__foot' }, [
      h('div', { class: 'ei-kb__sum' }, [
        h('p', { class: 'ei-kb__totalrow' }, [h('span', { class: 'ei-kb__totall', text: C.totalL }), el.total]),
        el.meta,
        el.nudge
      ]),
      h('div', { class: 'ei-kb__acts' }, [el.prev, el.next]),
      el.ferr
    ]);
    el.live = h('div', { class: 'ei-kb-vh', 'aria-live': 'polite', 'aria-atomic': 'true' });
    dlg.appendChild(h('div', { class: 'ei-kb__frame' }, [head, el.body, foot, el.live]));
    document.body.appendChild(dlg);

    el.x.addEventListener('click', function () { close(); });
    el.back.addEventListener('click', function () { if (cur && cur.step > 1) go(cur.step - 1); else close(); });
    el.prev.addEventListener('click', function () { if (cur && cur.step > 1) go(cur.step - 1); });
    el.next.addEventListener('click', onNext);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); if (!busy) close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg && !busy) close(); });
    window.addEventListener('popstate', function () {
      if (!dlg.open) { pushed = false; return; }
      pushed = false;
      if (busy) { try { history.pushState({ eiKb: 1 }, ''); pushed = true; } catch (e) { /* ignore */ } return; }
      close(true);
    });
  }

  function say(s) {
    el.live.textContent = '';
    window.setTimeout(function () { el.live.textContent = s; }, 40);
  }
  function sayTotal() {
    window.clearTimeout(liveTimer);
    liveTimer = window.setTimeout(function () {
      if (!cur) return;
      var t = calc(cur);
      say(C.liveTotal(t.items, cur.D.money(t.total)));
    }, 900);
  }

  function open(section, k, trigger) {
    var D = dataFor(section);
    if (!D || !D.k[k]) return false;
    if (!dlg) build();
    if (typeof dlg.showModal !== 'function') return false;
    var crewBtn = section.querySelector('[data-crew][aria-pressed="true"]');
    var crew = crewBtn ? parseInt(crewBtn.getAttribute('data-crew'), 10) || D.crew : D.crew;
    cur = stateFor(section, D, k, crew);
    cur.step = 1;
    opener = trigger || null;
    el.eyeD.textContent = C.eyebrow;
    el.title.textContent = cur.kit.n;
    el.ferr.textContent = '';
    busy = false;
    dlg.classList.remove('is-busy');
    render();
    dlg.showModal();
    document.documentElement.classList.add('ei-kb-lock');
    try { history.pushState({ eiKb: 1 }, ''); pushed = true; } catch (e) { pushed = false; }
    focusStep();
    ensureLogo(D);
    refresh(D).then(function (changed) { if (changed && cur && cur.D === D && dlg.open && !busy) { rerenderKeep(); } });
    getJSON(cartJsUrl()).then(function (c) {
      if (!c || !cur || cur.D !== D) return;
      cur.cartCount = countItems(c);
      if (dlg.open) paintCartNote();
    });
    return true;
  }
  function close(fromPop) {
    if (!dlg || !dlg.open || closing) return;
    closing = true;
    dlg.close();
    document.documentElement.classList.remove('ei-kb-lock');
    if (!fromPop && pushed) { pushed = false; try { history.back(); } catch (e) { /* ignore */ } }
    closing = false;
    if (opener && document.contains(opener)) opener.focus({ preventScroll: true });
  }
  function countItems(c) {
    var n = 0;
    (c.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (p._type !== 'service') n += it.quantity || 0;
    });
    return n;
  }
  function ensureLogo(D) {
    if (L()) return Promise.resolve(L());
    return new Promise(function (resolve) {
      var done = false;
      function fin() { if (!done) { done = true; resolve(L()); if (cur && cur.step === 2 && dlg.open) render(); } }
      document.addEventListener('ei:logo:ready', fin, { once: true });
      if (D.logoCss && !document.querySelector('link[data-ei-logo-css]')) {
        document.head.appendChild(h('link', { rel: 'stylesheet', href: D.logoCss, 'data-ei-logo-css': '' }));
      }
      if (D.logoJs && !document.querySelector('script[data-ei-logo-js]')) {
        var s = h('script', { src: D.logoJs, 'data-ei-logo-js': '' });
        s.addEventListener('load', fin);
        s.addEventListener('error', fin);
        document.head.appendChild(s);
      }
      window.setTimeout(fin, 8000);
    });
  }

  /* ---------------- render ---------------- */
  function render() {
    var st = cur;
    dlg.setAttribute('data-step', String(st.step));
    var lis = el.steps.children;
    for (var i = 0; i < lis.length; i++) {
      var n = i + 1;
      lis[i].className = n < st.step ? 'is-done' : n === st.step ? 'is-on' : '';
      if (n === st.step) lis[i].setAttribute('aria-current', 'step');
      else lis[i].removeAttribute('aria-current');
    }
    el.eyeM.textContent = C.stepOf(st.step) + ': ' + C.steps[st.step - 1];
    el.back.classList.toggle('is-off', st.step === 1);
    el.body.innerHTML = '';
    el.body.scrollTop = 0;
    if (st.step === 1) el.body.appendChild(step1(st));
    else if (st.step === 2) el.body.appendChild(step2(st));
    else el.body.appendChild(step3(st));
    paintFoot();
  }
  function rerenderKeep() {
    var y = el.body.scrollTop;
    var a = document.activeElement;
    var key = a && a.getAttribute ? a.getAttribute('data-k') : null;
    render();
    el.body.scrollTop = y;
    if (key) {
      var b = el.body.querySelector('[data-k="' + key + '"]');
      if (b) b.focus({ preventScroll: true });
    }
  }
  function focusStep() {
    var hd = el.body.querySelector('.ei-kb-pane__h');
    (hd || el.title).focus({ preventScroll: true });
  }
  function go(n) {
    cur.step = n;
    el.ferr.textContent = '';
    render();
    focusStep();
  }

  function paintFoot() {
    var st = cur, D = st.D, t = calc(st);
    el.total.textContent = D.money(t.total);
    var bits = [];
    if (t.items === 0) bits.push(C.noItems);
    else {
      bits.push(nItems(t.items));
      bits.push(t.pct ? C.off(t.pct) : C.standard);
      bits.push(t.fee ? C.feeIn(D.feeText) : t.items >= D.waive ? C.feeWaived : C.feeReorder);
    }
    el.meta.textContent = bits.join(' · ');
    el.nudge.textContent = nudge(st, t);
    el.nudge.classList.toggle('is-top', t.items >= 48);
    el.prev.hidden = st.step === 1;
    var upBusy = st.up && st.up.busy && st.up.busy() && st.logo === 'upload';
    if (st.step === 1) el.next.innerHTML = '<span>' + C.next1 + '</span>' + ic('next');
    else if (st.step === 2) el.next.innerHTML = '<span>' + C.next2 + '</span>' + ic('next');
    else if (busy) el.next.innerHTML = '<span class="ei-kb-spin" aria-hidden="true"></span><span>' + (busy === 'done' ? C.added : C.adding) + '</span>';
    else if (upBusy) el.next.innerHTML = '<span class="ei-kb-spin" aria-hidden="true"></span><span>' + C.finishing + '</span>';
    else el.next.innerHTML = ic('cart') + '<span>' + C.add(t.items) + '</span>';
    el.next.disabled = !!busy || (st.step === 3 && (upBusy || t.items === 0));
    // per-product counters on step 1
    if (st.step === 1) {
      st.kit.p.forEach(function (pi) {
        var box = el.body.querySelector('[data-pi="' + pi + '"]');
        if (!box) return;
        var q = prodCount(st, pi);
        var badge = box.querySelector('[data-count]');
        if (badge) {
          badge.querySelector('b').textContent = C.picked(q, st.crew);
          badge.classList.toggle('is-ok', q >= st.crew);
          badge.classList.toggle('is-zero', q === 0);
          badge.querySelector('.ei-kb-vh').textContent = C.pickedSr(q, st.crew, st.D.p[pi].n);
        }
        Array.prototype.forEach.call(box.querySelectorAll('[data-rowsum]'), function (s) {
          var ci = parseInt(s.getAttribute('data-rowsum'), 10);
          s.textContent = C.rowPicked(colCount(st, st.D.p[pi], ci));
        });
      });
    }
  }
  function paintCartNote() {
    var n = el.body.querySelector('[data-cartnote]');
    if (!n || !cur) return;
    if (cur.cartCount > 0) { n.hidden = false; n.querySelector('span').textContent = C.inCart(cur.cartCount); }
    else n.hidden = true;
  }

  /* Step 1: colors, sizes, quantities */
  function step1(st) {
    var D = st.D;
    var pane = h('section', { class: 'ei-kb-pane', 'aria-labelledby': 'ei-kb-s1' });
    pane.appendChild(h('div', { class: 'ei-kb-pane__top' }, [
      h('div', {}, [
        h('h3', { class: 'ei-kb-pane__h', id: 'ei-kb-s1', tabindex: '-1', 'data-k': 'pane-h', text: C.s1h }),
        h('p', { class: 'ei-kb-pane__l', text: C.s1lede(D.unit) })
      ]),
      crewCtl(st)
    ]));
    var note = h('p', { class: 'ei-kb-note', 'data-cartnote': '', hidden: true, html: ic('info') + '<span></span>' });
    pane.appendChild(note);
    st.kit.p.forEach(function (pi) { pane.appendChild(prodBlock(st, D.p[pi])); });
    window.setTimeout(paintCartNote, 0);
    return pane;
  }
  function crewCtl(st) {
    var D = st.D;
    var inp = h('input', { type: 'text', inputmode: 'numeric', pattern: '[0-9]*', class: 'ei-kb-crew__in', value: String(st.crew), 'aria-label': C.crewInput, 'data-k': 'crew' });
    function set(n) {
      n = Math.max(1, Math.min(999, n));
      var old = st.crew;
      if (n === old) { inp.value = String(n); return; }
      st.crew = n;
      inp.value = String(n);
      // untouched quantities follow the crew size
      st.kit.p.forEach(function (pi) {
        var P = D.p[pi];
        if (P.sized || st.sel[pi].length !== 1) return;
        var v = P.cols[st.sel[pi][0]].bySi[-1];
        if (v && v.av && qOf(st, v.id) === old) st.lines[v.id] = n;
      });
      rerenderKeep();
      sayTotal();
    }
    inp.addEventListener('change', function () { set(clampQ(inp.value) || 1); });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowUp') { e.preventDefault(); set(st.crew + 1); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); set(st.crew - 1); }
      else if (e.key === 'Enter') { e.preventDefault(); set(clampQ(inp.value) || 1); }
    });
    return h('div', { class: 'ei-kb-crew', role: 'group', 'aria-label': C.crewInput }, [
      h('span', { class: 'ei-kb-crew__l', text: C.crewL }),
      h('div', { class: 'ei-kb-qty ei-kb-qty--crew' }, [
        h('button', { type: 'button', class: 'ei-kb-qty__b', 'aria-label': C.crewLess, 'data-k': 'crew-less', html: ic('minus'), onclick: function () { set(st.crew - 1); } }),
        inp,
        h('button', { type: 'button', class: 'ei-kb-qty__b', 'aria-label': C.crewMore, 'data-k': 'crew-more', html: ic('plus'), onclick: function () { set(st.crew + 1); } })
      ]),
      h('span', { class: 'ei-kb-crew__u', text: st.crew === 1 ? D.unit : D.units })
    ]);
  }
  function priceText(D, P) {
    return P.min === P.max ? C.each(D.money(P.min)) : C.from(D.money(P.min));
  }
  function prodBlock(st, P) {
    var D = st.D;
    var box = h('div', { class: 'ei-kb-prod', 'data-pi': String(P.pi) });
    var badge = h('span', { class: 'ei-kb-prod__c', 'data-count': '' }, [h('b', { 'aria-hidden': 'true' }), h('span', { class: 'ei-kb-vh' })]);
    box.appendChild(h('div', { class: 'ei-kb-prod__head' }, [
      h('span', { class: 'ei-kb-prod__img' }, [prodImg(st, P) ? h('img', { src: prodImg(st, P), alt: '', width: '56', height: '56', loading: 'lazy', decoding: 'async' }) : null]),
      h('div', { class: 'ei-kb-prod__t' }, [
        h('h4', { class: 'ei-kb-prod__n', text: P.n }),
        h('p', { class: 'ei-kb-prod__p', text: priceText(D, P) + ' · ' + C.need(st.crew, D.unit) })
      ]),
      badge
    ]));
    box.appendChild(h('p', { class: 'ei-kb-prod__hint', text: P.sized ? C.sizedHint : C.unsizedHint }));

    // swatches
    var grid = h('div', { class: 'ei-kb-sw__grid' });
    var many = P.cols.length > COLLAPSE;
    var moreBtn = many ? h('button', { type: 'button', class: 'ei-kb-sw__more', 'aria-expanded': st.more[P.pi] ? 'true' : 'false', 'data-k': 'more-' + P.pi }) : null;
    function paintSw() {
      var open = !!st.more[P.pi];
      Array.prototype.forEach.call(grid.children, function (b) {
        var ci = parseInt(b.getAttribute('data-ci'), 10);
        var on = st.sel[P.pi].indexOf(ci) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.hidden = many && !open && ci >= COLLAPSE && !on && b !== document.activeElement;
      });
      if (moreBtn) {
        moreBtn.textContent = open ? C.showFewer : C.showAll(P.cols.length);
        moreBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
    P.cols.forEach(function (col) {
      var out = !col.av;
      var b = h('button', {
        type: 'button',
        class: 'ei-kb-swatch' + (out ? ' is-out' : ''),
        'data-ci': String(col.ci),
        'data-k': 'sw-' + P.pi + '-' + col.ci,
        'aria-pressed': 'false',
        'aria-disabled': out ? 'true' : null,
        title: col.name + (out ? ' (' + C.soldOut + ')' : '')
      }, [
        h('span', { class: 'ei-kb-swatch__img' }, [col.img ? h('img', { src: col.img, alt: '', width: '64', height: '64', loading: 'lazy', decoding: 'async' }) : null, h('span', { class: 'ei-kb-swatch__ok', html: ic('check') })]),
        nameEl('span', 'ei-kb-swatch__n', col.name),
        out ? h('span', { class: 'ei-kb-swatch__s', text: C.soldOut }) : null
      ]);
      b.addEventListener('click', function () {
        if (out) return;
        var list = st.sel[P.pi];
        var at = list.indexOf(col.ci);
        if (at > -1) {
          list.splice(at, 1);
          col.vars.forEach(function (v) { setQ(st, v.id, 0); });
          say(C.removed1(col.name));
        } else {
          list.push(col.ci);
          if (!P.sized) {
            var v = col.bySi[-1] || col.vars[0];
            var have = prodCount(st, P.pi);
            if (v && v.av) setQ(st, v.id, Math.max(1, st.crew - have));
          }
          st.pristine = false;
          say(C.added1(col.name));
        }
        paintSw();
        paintRows();
        paintFoot();
        sayTotal();
      });
      grid.appendChild(b);
    });
    var sw = h('div', { class: 'ei-kb-sw', role: 'group', 'aria-label': (P.cn || C.colorsL) + ', ' + P.n }, [
      h('p', { class: 'ei-kb-sw__l' }, [h('b', { text: C.colorsL }), ' ', h('span', { text: '(' + P.cols.length + ')' })]),
      grid,
      moreBtn
    ]);
    if (moreBtn) moreBtn.addEventListener('click', function () { st.more[P.pi] = !st.more[P.pi]; paintSw(); });
    box.appendChild(sw);

    // chosen colors
    var rows = h('div', { class: 'ei-kb-rows' });
    function paintRows() {
      rows.innerHTML = '';
      st.sel[P.pi].forEach(function (ci) { rows.appendChild(P.sized ? sizedRow(st, P, ci) : qtyRow(st, P, ci)); });
    }
    paintRows();
    box.appendChild(rows);
    paintSw();
    return box;
  }
  function rowRemove(st, P, ci) {
    var col = P.cols[ci];
    return h('button', {
      type: 'button',
      class: 'ei-kb-row__x',
      'aria-label': C.remove(col.name),
      'data-k': 'rm-' + P.pi + '-' + ci,
      html: ic('close'),
      onclick: function () {
        var list = st.sel[P.pi];
        var at = list.indexOf(ci);
        if (at > -1) list.splice(at, 1);
        col.vars.forEach(function (v) { setQ(st, v.id, 0); });
        say(C.removed1(col.name));
        rerenderKeep();
        var sw = el.body.querySelector('[data-k="sw-' + P.pi + '-' + ci + '"]');
        if (sw && !sw.hidden) sw.focus({ preventScroll: true });
        sayTotal();
      }
    });
  }
  function qtyRow(st, P, ci) {
    var col = P.cols[ci];
    var v = col.bySi[-1] || col.vars[0];
    var label = col.name + ' ' + (P.k || P.n);
    var inp = h('input', { type: 'text', inputmode: 'numeric', pattern: '[0-9]*', class: 'ei-kb-qty__in', value: String(qOf(st, v.id)), 'aria-label': C.qtyFor(label), 'data-k': 'q-' + v.id });
    function set(n) {
      n = Math.max(0, Math.min(MAXQ, n));
      setQ(st, v.id, n);
      inp.value = String(n);
      paintFoot();
      sayTotal();
    }
    inp.addEventListener('input', function () { setQ(st, v.id, clampQ(inp.value)); paintFoot(); sayTotal(); });
    inp.addEventListener('blur', function () { inp.value = String(qOf(st, v.id)); });
    inp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowUp') { e.preventDefault(); set(qOf(st, v.id) + 1); }
      else if (e.key === 'ArrowDown') { e.preventDefault(); set(qOf(st, v.id) - 1); }
    });
    var row = h('div', { class: 'ei-kb-row' + (v.av ? '' : ' is-out') }, [
      h('span', { class: 'ei-kb-row__img' }, [col.img ? h('img', { src: col.img, alt: '', width: '44', height: '44', loading: 'lazy', decoding: 'async' }) : null]),
      h('span', { class: 'ei-kb-row__n' }, [h('b', { text: col.name }), h('span', { text: v.av ? C.each(st.D.money(v.price)) : C.soldOutRow })]),
      h('div', { class: 'ei-kb-qty' }, [
        h('button', { type: 'button', class: 'ei-kb-qty__b', 'aria-label': C.less(label), 'data-k': 'ql-' + v.id, html: ic('minus'), onclick: function () { set(qOf(st, v.id) - 1); } }),
        inp,
        h('button', { type: 'button', class: 'ei-kb-qty__b', 'aria-label': C.more(label), 'data-k': 'qm-' + v.id, html: ic('plus'), disabled: v.av ? null : true, onclick: function () { set(qOf(st, v.id) + 1); } })
      ]),
      rowRemove(st, P, ci)
    ]);
    return row;
  }
  function sizedRow(st, P, ci) {
    var col = P.cols[ci];
    var grid = h('div', { class: 'ei-kb-sizes', role: 'group', 'aria-label': C.sizesFor(col.name) });
    P.z.forEach(function (sz, si) {
      var v = col.bySi[si];
      if (!v) return;
      var cell;
      if (!v.av && !qOf(st, v.id)) {
        cell = h('div', { class: 'ei-kb-size is-out' }, [
          h('span', { class: 'ei-kb-size__l', text: sz }),
          h('span', { class: 'ei-kb-size__in ei-kb-size__in--off', 'aria-hidden': 'true', text: '-' }),
          h('span', { class: 'ei-kb-size__p', text: C.soldOut }),
          h('span', { class: 'ei-kb-vh', text: col.name + ', size ' + sz + ', ' + C.soldOut })
        ]);
      } else {
        var q = qOf(st, v.id);
        var inp = h('input', { type: 'text', inputmode: 'numeric', pattern: '[0-9]*', class: 'ei-kb-size__in', value: q ? String(q) : '', placeholder: '0', 'aria-label': C.sizeQty(sz, col.name), 'data-k': 'q-' + v.id });
        inp.addEventListener('input', function () {
          setQ(st, v.id, clampQ(inp.value));
          cell.classList.toggle('is-on', qOf(st, v.id) > 0);
          paintFoot();
          sayTotal();
        });
        inp.addEventListener('blur', function () { var n = qOf(st, v.id); inp.value = n ? String(n) : ''; });
        inp.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
            var n = qOf(st, v.id) + (e.key === 'ArrowUp' ? 1 : -1);
            setQ(st, v.id, Math.max(0, Math.min(MAXQ, n)));
            inp.value = qOf(st, v.id) ? String(qOf(st, v.id)) : '';
            cell.classList.toggle('is-on', qOf(st, v.id) > 0);
            paintFoot();
            sayTotal();
          }
        });
        cell = h('label', { class: 'ei-kb-size' + (q > 0 ? ' is-on' : '') + (v.av ? '' : ' is-out') }, [
          h('span', { class: 'ei-kb-size__l', text: sz }),
          inp,
          h('span', { class: 'ei-kb-size__p', text: v.av ? st.D.money(v.price) : C.soldOut })
        ]);
      }
      grid.appendChild(cell);
    });
    return h('div', { class: 'ei-kb-row ei-kb-row--sized' }, [
      h('div', { class: 'ei-kb-row__top' }, [
        h('span', { class: 'ei-kb-row__img' }, [col.img ? h('img', { src: col.img, alt: '', width: '44', height: '44', loading: 'lazy', decoding: 'async' }) : null]),
        h('span', { class: 'ei-kb-row__n' }, [h('b', { text: col.name }), h('span', { 'data-rowsum': String(ci), text: C.rowPicked(colCount(st, P, ci)) })]),
        rowRemove(st, P, ci)
      ]),
      grid
    ]);
  }

  /* Step 2: logo */
  function step2(st) {
    var lg = L();
    var saved = lg ? lg.read() : null;
    if (st.logo === 'saved' && !saved) st.logo = 'upload';
    var pane = h('section', { class: 'ei-kb-pane ph-no-capture', 'aria-labelledby': 'ei-kb-s2' });
    pane.appendChild(h('h3', { class: 'ei-kb-pane__h', id: 'ei-kb-s2', tabindex: '-1', 'data-k': 'pane-h', text: C.s2h }));
    pane.appendChild(h('p', { class: 'ei-kb-pane__l', text: C.s2lede }));
    var fs = h('fieldset', { class: 'ei-kb-opts' }, [h('legend', { class: 'ei-kb-vh', text: C.logoLegend })]);
    var name = 'ei-kb-logo-' + st.k;
    function opt(val, title, sub, extra) {
      var r = h('input', { type: 'radio', name: name, value: val, class: 'ei-kb-opt__r', checked: st.logo === val ? true : null, 'data-k': 'logo-' + val });
      r.addEventListener('change', function () {
        if (!r.checked) return;
        st.logo = val;
        Array.prototype.forEach.call(fs.querySelectorAll('.ei-kb-opt'), function (o) { o.classList.toggle('is-on', o.getAttribute('data-v') === val); });
        var panel = fs.querySelector('.ei-kb-opt__panel');
        if (panel) panel.hidden = val !== 'upload';
        paintFoot();
      });
      var lab = h('label', { class: 'ei-kb-opt' + (st.logo === val ? ' is-on' : ''), 'data-v': val }, [
        r,
        h('span', { class: 'ei-kb-opt__dot', 'aria-hidden': 'true' }),
        h('span', { class: 'ei-kb-opt__b' }, [h('b', { text: title }), sub ? h('span', { text: sub }) : null]),
        extra || null
      ]);
      return lab;
    }
    if (saved && lg) fs.appendChild(opt('saved', C.optSaved, saved.name || C.logoSaved, lg.thumbEl(saved.url, saved.name, 112, 'ei-lg-th--m')));
    fs.appendChild(opt('upload', C.optUpload, C.optUploadSub));
    if (lg) {
      if (!st.up) {
        st.up = lg.Uploader({ src: 'kit', onChange: function () { if (cur !== st || !dlg.open) return; if (st.step === 3) rerenderKeep(); else paintFoot(); } });
      }
      var panel = h('div', { class: 'ei-kb-opt__panel', hidden: st.logo !== 'upload' ? true : null }, [st.up.el]);
      fs.appendChild(panel);
    }
    fs.appendChild(opt('reorder', C.optReorder, C.optReorderSub));
    fs.appendChild(opt('later', C.optLater, C.optLaterSub));
    pane.appendChild(fs);
    pane.appendChild(h('p', { class: 'ei-kb-proof', html: ic('check') + '<span></span>' }));
    pane.lastChild.querySelector('span').textContent = C.proof;
    return pane;
  }

  /* Step 3: review */
  function step3(st) {
    var D = st.D, t = calc(st);
    var pane = h('section', { class: 'ei-kb-pane', 'aria-labelledby': 'ei-kb-s3' });
    pane.appendChild(h('h3', { class: 'ei-kb-pane__h', id: 'ei-kb-s3', tabindex: '-1', 'data-k': 'pane-h', text: C.s3h }));
    var ul = h('ul', { class: 'ei-kb-sum', role: 'list' });
    st.kit.p.forEach(function (pi) {
      var P = D.p[pi];
      var parts = [], sub = 0, n = 0;
      st.sel[pi].forEach(function (ci) {
        var col = P.cols[ci];
        var bits = [];
        col.vars.forEach(function (v) {
          var q = qOf(st, v.id);
          if (!q) return;
          n += q;
          sub += q * v.price;
          bits.push(P.sized ? P.z[v.si] + ' x ' + q : 'x ' + q);
        });
        if (bits.length) parts.push(col.name + (P.sized ? ': ' : ' ') + bits.join(', '));
      });
      ul.appendChild(h('li', { class: 'ei-kb-sum__i' + (n ? '' : ' is-off') }, [
        h('span', { class: 'ei-kb-sum__img' }, [prodImg(st, P) ? h('img', { src: prodImg(st, P), alt: '', width: '48', height: '48', loading: 'lazy' }) : null]),
        h('span', { class: 'ei-kb-sum__b' }, [h('b', { text: P.n }), h('span', { text: n ? parts.join('; ') : C.none })]),
        h('span', { class: 'ei-kb-sum__p', text: n ? D.money(sub) : '' })
      ]));
    });
    pane.appendChild(ul);

    // logo line
    var lg = L(), saved = lg ? lg.read() : null, up = st.up ? st.up.state() : null;
    var logoTxt, logoThumb = null;
    if (st.logo === 'saved' && saved) { logoTxt = C.logoSaved; logoThumb = lg.thumbEl(saved.url, saved.name, 96, 'ei-lg-th--m'); }
    else if (st.logo === 'upload' && up && up.status === 'done' && up.url) { logoTxt = C.logoNew; logoThumb = lg.thumbEl(up.url, up.name, 96, 'ei-lg-th--m'); }
    else if (st.logo === 'upload') logoTxt = C.logoNotYet;
    else if (st.logo === 'reorder') logoTxt = C.logoReorder;
    else logoTxt = C.logoLater;
    pane.appendChild(h('div', { class: 'ei-kb-sumlogo ph-no-capture' }, [
      logoThumb || h('span', { class: 'ei-kb-sumlogo__ic', html: ic(st.logo === 'reorder' ? 'refresh' : 'upload') }),
      h('span', {}, [h('b', { text: C.logoL }), h('span', { text: logoTxt })]),
      h('button', { type: 'button', class: 'ei-kb-link', text: 'Change', 'data-k': 'logo-change', onclick: function () { go(2); } })
    ]));

    var dl = h('dl', { class: 'ei-kb-calc' });
    function row(a, b, cls) { dl.appendChild(h('div', { class: cls || null }, [h('dt', { text: a }), h('dd', { text: b })])); }
    row(C.rowItems(t.items), D.money(t.list));
    if (t.pct) row(C.rowDisc(t.pct), '-' + D.money(t.save), 'is-save');
    row(C.rowFee, t.fee ? D.money(t.fee) : t.items >= D.waive ? C.waived : t.reorder ? C.waivedReorder : C.waived);
    row(C.estTotal, D.money(t.total), 'is-total');
    pane.appendChild(dl);
    var fine = h('p', { class: 'ei-kb-fine', text: C.fine });
    pane.appendChild(fine);
    var note = h('p', { class: 'ei-kb-note', 'data-cartnote': '', hidden: true, html: ic('info') + '<span></span>' });
    pane.appendChild(note);
    window.setTimeout(paintCartNote, 0);
    pane.appendChild(h('div', { class: 'ei-kb-err', 'data-err': '', role: 'alert', hidden: true }));
    return pane;
  }

  /* ---------------- next / add ---------------- */
  function onNext() {
    if (!cur || busy) return;
    var t = calc(cur);
    if (cur.step === 1) {
      if (t.items === 0) {
        el.ferr.textContent = C.needOne;
        var first = el.body.querySelector('.ei-kb-swatch:not(.is-out)');
        if (first) first.focus();
        return;
      }
      el.ferr.textContent = '';
      go(2);
    } else if (cur.step === 2) {
      go(3);
    } else {
      add();
    }
  }

  function payload(st) {
    var items = [];
    st.kit.p.forEach(function (pi) {
      var P = st.D.p[pi];
      P.v.forEach(function (a) {
        var q = qOf(st, a[0]);
        if (!(q > 0)) return;
        // key order is part of the order contract: _type, _product_type, _features (same as the PDP)
        items.push({ id: a[0], quantity: q, properties: { _type: 'product', _product_type: P.pt === undefined ? null : P.pt, _features: P.f } });
      });
    });
    return items;
  }
  function showErr(lines, withCart) {
    var box = el.body.querySelector('[data-err]');
    if (!box) return;
    box.innerHTML = '';
    var p = h('p', { class: 'ei-kb-err__t', html: ic('alert') + '<span></span>' });
    p.querySelector('span').textContent = lines[0];
    box.appendChild(p);
    if (lines.length > 2) {
      var ul = h('ul', { role: 'list' });
      lines.slice(1, -1).forEach(function (s) { ul.appendChild(h('li', { text: s })); });
      box.appendChild(ul);
    }
    if (lines.length > 1) box.appendChild(h('p', { text: lines[lines.length - 1] }));
    if (withCart) box.appendChild(h('a', { class: 'ei-kb-link', href: cur.D.cart, text: C.goCart }));
    box.hidden = false;
    box.scrollIntoView({ block: 'nearest', behavior: still() ? 'auto' : 'smooth' });
  }
  function snapshot(c) {
    var m = {};
    ((c && c.items) || []).forEach(function (it) { m[it.key] = it.quantity; });
    return m;
  }
  /* Put back every line the failed request grew (Shopify adds what it can before answering 422). */
  function rollback(before, after, ids) {
    var grew = [];
    ((after && after.items) || []).forEach(function (it) {
      if (!ids[it.variant_id]) return;
      var was = before[it.key] || 0;
      if (it.quantity > was) grew.push({ key: it.key, was: was, now: it.quantity, vid: it.variant_id });
    });
    var ok = true;
    var chain = Promise.resolve();
    grew.forEach(function (g) {
      chain = chain.then(function () {
        return postJSON(changeUrl(), { id: g.key, quantity: g.was }).then(function (r) { if (!r.ok) ok = false; });
      });
    });
    return chain.then(function () { return { grew: grew, ok: ok }; });
  }

  function add() {
    var st = cur, D = st.D;
    var items = payload(st);
    if (!items.length) return;
    var bad = soldOutPicked(st);
    if (bad.length) {
      go(1);
      el.ferr.textContent = C.soldOutRow;
      return;
    }
    busy = 'adding';
    dlg.classList.add('is-busy');
    paintFoot();
    var errBox = el.body.querySelector('[data-err]');
    if (errBox) errBox.hidden = true;
    var ids = {};
    items.forEach(function (it) { ids[it.id] = it.quantity; });
    var beforeCart = null;
    getJSON(cartJsUrl()).then(function (c) {
      beforeCart = c;
      return postJSON(D.add, { items: items });
    }).then(function (r) {
      if (r.ok && r.json && r.json.items) return success(st);
      return getJSON(cartJsUrl()).then(function (after) {
        if (!beforeCart || !after) {
          try { window.dispatchEvent(new CustomEvent('__cart_reload')); } catch (e) { /* ignore */ }
          fail([C.errUnknown], true);
          return;
        }
        var before = snapshot(beforeCart);
        // what Shopify managed to add per variant = what it has in stock for this request
        var addedBy = {};
        ((after.items) || []).forEach(function (it) {
          if (!ids[it.variant_id]) return;
          var d = it.quantity - (before[it.key] || 0);
          if (d > 0) addedBy[it.variant_id] = (addedBy[it.variant_id] || 0) + d;
        });
        return rollback(before, after, ids).then(function (rb) {
          if (!rb.ok) {
            try { window.dispatchEvent(new CustomEvent('__cart_reload')); } catch (e) { /* ignore */ }
            fail([C.errPartial], true);
            return;
          }
          if (r.status !== 422) { fail([C.errGeneric], false); return; }
          var adj = [];
          items.forEach(function (it) {
            var got = addedBy[it.id] || 0;
            if (got >= it.quantity) return;
            var pi = st.vmap[it.id];
            var P = D.p[pi];
            var v = P.byId[it.id];
            var col = P.cols[v.ci];
            setQ(st, it.id, got);
            if (got === 0) v.av = false;
            adj.push(C.adj(P.n + ', ' + col.name + (P.sized ? ' ' + P.z[v.si] : ''), got));
          });
          if (!adj.length) { fail([C.errStockNone], false); return; }
          busy = false;
          dlg.classList.remove('is-busy');
          rerenderKeep();
          showErr([C.errStock].concat(adj).concat([C.errStockTail]), false);
          el.next.focus({ preventScroll: true });
        });
      });
    }).catch(function () { fail([C.errGeneric], false); });
  }
  function fail(lines, withCart) {
    busy = false;
    dlg.classList.remove('is-busy');
    paintFoot();
    showErr(lines, withCart);
  }
  function success(st) {
    var D = st.D, lg = L();
    busy = 'done';
    paintFoot();
    var up = st.up ? st.up.state() : null;
    var offered = false;
    if (lg && st.logo === 'upload' && up && up.status === 'done' && up.url && up.storable) {
      var rec = lg.write({ url: up.url, name: up.name, w: up.w, h: up.h, src: 'kit' });
      if (rec) { lg.offer(rec); lg.render(rec); offered = true; }
    } else if (lg && st.logo === 'saved') {
      // a logo uploaded in the cart is remembered for the header only (src "cart") and the cart never applies it
      // on its own, so the logo the shopper picked here must be offered like a fresh upload
      var saved = lg.read();
      if (saved && saved.src === 'cart') { lg.offer({ url: saved.url, name: saved.name, src: 'kit' }); offered = true; }
    }
    try { window.dispatchEvent(new CustomEvent('__cart_reload')); } catch (e) { /* ignore */ }
    var eng = window.__eiCart;
    var wait = eng && typeof eng.whenIdle === 'function'
      ? sleep(offered ? 200 : 120).then(function () { return eng.whenIdle(6000); }).catch(function () {})
      : sleep(350);
    return wait.then(function () {
      pushed = false;
      window.location.replace(D.cart);
    });
  }

  /* ---------------- wiring ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ei-kit-open]') : null;
    if (!b) return;
    var section = b.closest('[data-ei-ind-kits]');
    if (!section) return;
    var k = parseInt(b.getAttribute('data-ei-kit-open'), 10);
    if (!isFinite(k)) return;
    if (open(section, k, b)) e.preventDefault();
  });
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted && dlg && dlg.open) close(true);
  });
})();
